export default __webpack_public_path__ + "static/media/top_skills_framed.66f6df1a.png";